/** Clear compute_error on every item and field in a tree items record. */
export function clearTreeErrors(
    items: Record<string, any>,
): Record<string, any> {
    const cleared = { ...items };
    Object.keys(cleared).forEach((key) => {
        const obj = cleared[key];
        const patched = { ...obj, compute_error: null };
        if (patched.fields) {
            const newFields = { ...patched.fields };
            Object.keys(newFields).forEach((fKey) => {
                newFields[fKey] = { ...newFields[fKey], compute_error: null };
            });
            patched.fields = newFields;
        }
        cleared[key] = patched;
    });
    return cleared;
}
